import React, { useContext, useState } from 'react';

import ScoutTalentLogo from './ScoutTalentLogo';
import { PortalLogoContext } from '../portalLogoContext';
import { usePortalCompact } from '../usePortalCompact';

const PortalLogo: React.FC = () => {
  const logo = useContext(PortalLogoContext);
  const compact = usePortalCompact();
  // A logo that fails to load falls back to the Scout Talent logo, not a broken image.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (!logo || logo.url === failedUrl) return <ScoutTalentLogo />;

  return (
    <img
      alt={logo.alt}
      onError={() => setFailedUrl(logo.url)}
      src={logo.url}
      style={{
        display: 'block',
        width: 'auto',
        height: 'auto',
        maxWidth: `min(${compact ? 180 : 240}px, 100%)`,
        maxHeight: compact ? 40 : 56
      }}
    />
  );
};

export default PortalLogo;
